export type ColorInterfaceToken =
  | "color.ui.bg.default"
  | "color.ui.bg.surface"
  | "color.ui.bg.subtle"
  | "color.ui.bg.hover"
  | "color.ui.text.primary"
  | "color.ui.text.secondary"
  | "color.ui.text.disabled"
  | "color.ui.text.inverse"
  | "color.ui.icon.primary"
  | "color.ui.icon.secondary"
  | "color.ui.action.primary"
  | "color.ui.action.secondary"
  | "color.ui.border.default"
  | "color.ui.border.secondary"
  | "color.ui.border.subtle"
  | "color.ui.border.hover";

export const COLOR_INTERFACE_TOKENS: ColorInterfaceToken[] = [
  "color.ui.bg.default",
  "color.ui.bg.surface",
  "color.ui.bg.subtle",
  "color.ui.bg.hover",
  "color.ui.text.primary",
  "color.ui.text.secondary",
  "color.ui.text.disabled",
  "color.ui.text.inverse",
  "color.ui.icon.primary",
  "color.ui.icon.secondary",
  "color.ui.action.primary",
  "color.ui.action.secondary",
  "color.ui.border.default",
  "color.ui.border.secondary",
  "color.ui.border.subtle",
  "color.ui.border.hover"
];
